import { SurveyReducerState } from './types';

export const initialState: SurveyReducerState = {
  activity: null,
  surveyState: [],
  currentStep: {
    objUrl: '',
    progress: 0,
    status: 'default',
    uploadedStepInfo: '',
  },
};
